import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/production',
    name: 'production',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/production.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
  },
  {
    path: '/news_detail',
    name: 'news_detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/news_detail.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
  },
  {
    path: '/company_info',
    name: 'company_info',
    component: () => import(/* webpackChunkName: "about" */ '../views/company_info.vue')
  },
  {
    path: '/production_detail',
    name: 'production_detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/production_detail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0
  // 一定不要忘记调用 next()
  next()
})

router.beforeEach((to, from, next) => {
  if (to.fullPath == '/en') {
    window.location.href = 'http://www.mansul.com'
  }
  if (!(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))) {
    // window.location.href = 'http://mansul.com' + to.fullPath;
    window.location.href = to.fullPath === '/index' ? 'http://mansul.com.cn' : 'http://mansul.com.cn' + to.fullPath;
    if (to.fullPath == '/en') {
      window.location.href = 'http://www.mansul.com'
    }
    console.log(window.location.href, '跳转地址')
    return
  }
  next()
})

export default router
